import { Typography } from '@components/common/Typography';
import StyledAlert from '@components/common/Alert';
import { Container as AlertContainer } from '@components/common/Alert/Alert.styles';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 888px;
  margin: 0 auto;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    h4 {
      width: 516px;
      max-width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    padding: 0 1rem;
    ${AlertContainer} {
      margin-bottom: 2rem;
    }
  }
`;

export const FormContainer = styled.div`
  margin-bottom: 80px;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin-bottom: 60px;
  }
`;

export const Main = styled.main`
  display: flex;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    flex-direction: column;
  }
`;

export const Section = styled.section`
  width: 100%;
  width: 516px;
  max-width: 100%;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin: 0 auto;
  }
`;

export const FlexBreak = styled.div`
  flex-basis: 100%;
`;

export const QuestionsContainer = styled.div`
  margin-bottom: 200px;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin: 50px auto 160px;
    max-width: 324px;
    order: 1;
  }
`;

export const PageTitle = styled(Typography)`
  margin: 24px 0px;
  font-weight: 400;
`;

export const QuestionsTitle = styled(Typography)`
  margin-bottom: 1rem;
`;

export const Alert = styled(StyledAlert)`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: block;
  }
`;
